import { Container } from "react-bootstrap";
import NotFoundImage from "../../Assets/Images/NotFound.svg";
const NotFound = () => {
    return (
        <Container className="mt-5 mb-5 text-center">
            <div className="col-12 Center mt-3 mb-3">
                <img src={NotFoundImage} width="200px" alt="Campaign not found" />
            </div>
            <h2>Page not found</h2>
            <p>The page you're looking for doesn't exist or has been removed.</p>
        </Container>);
};

export default NotFound;
